import { Typography, TypographyProps } from '@mui/material';

const BodySecondaryText: React.FC<TypographyProps> = (props) => (
  <Typography
    variant="body2"
    color="textSecondary"
    sx={{ fontSize: '12px', wordWrap: 'break-word', whiteSpace: 'normal', width: '100%' }}
    {...props}
  />
);

export default BodySecondaryText;
